import React from "react";
import { Link } from "react-router-dom";
import { srcsetImage } from "../helpers";

class NewPost extends React.Component {
  render() {
    // Thumbnail styles
    if (Array.isArray(this.props.details.colors.thumbnail.bg)) {
      let thumbnailGradientSteps = [];

      this.props.details.colors.thumbnail.bg.map(step => {
        thumbnailGradientSteps.push(
          `${step.post_backgroundGradientColorValue} ${step.post_backgroundGradientColorLocation}%`
        );
        return null;
      });

      var thumbnailContainerStyle = {
        background: `linear-gradient(${thumbnailGradientSteps.join(", ")})`,
      };
    } else if (this.props.details.colors.thumbnail.bg) {
      thumbnailContainerStyle = {
        background: this.props.details.colors.thumbnail.bg,
      };
    }

    // Copy styles
    if (Array.isArray(this.props.details.colors.copy.bg)) {
      let copyGradientSteps = [];

      this.props.details.colors.copy.bg.map(step => {
        copyGradientSteps.push(
          `${step.post_backgroundGradientColorValue} ${step.post_backgroundGradientColorLocation}%`
        );
        return null;
      });

      var copyContainerStyle = {
        background: `linear-gradient(${copyGradientSteps.join(", ")})`,
      };
    } else {
      copyContainerStyle = {
        background: this.props.details.colors.copy.bg,
      };
    }

    let copyTextStyle = {
      color: this.props.details.colors.copy.text ? this.props.details.colors.copy.text : "#fff",
      fontWeight: this.props.details.colors.text ? "normal" : "",
    };

    let copyLinkStyle = {
      color: this.props.details.colors.copy.link ? this.props.details.colors.copy.link : "",
      fontWeight: this.props.details.colors.text ? "normal" : "",
    };

    return (
      <article className="new--post">
        <div className="new--thumbnailContainer" style={thumbnailContainerStyle}>
          {this.props.details.relatedProject && (
            <Link to={`/work/project/${this.props.details.relatedProject}/`}>
              {srcsetImage(this.props.details.image)}
            </Link>
          )}
          {!this.props.details.relatedProject && srcsetImage(this.props.details.image)}
        </div>
        <div className="new--copyContainer" style={copyContainerStyle}>
          <div className="new--copyContainer--inner">
            {this.props.details.relatedProject && (
              <Link to={`/work/project/${this.props.details.relatedProject}/`}>
                <h1 className="new--title" style={copyTextStyle}>
                  {this.props.details.title}
                </h1>
              </Link>
            )}
            {!this.props.details.relatedProject && (
              <h1 className="new--title">{this.props.details.title}</h1>
            )}
            <div
              className="new--copy"
              dangerouslySetInnerHTML={{ __html: this.props.details.content }}
              style={copyTextStyle}
            />
            {this.props.details.relatedProject && (
              <Link
                className="new--relatedProject"
                to={`/work/project/${this.props.details.relatedProject}/`}
                style={copyLinkStyle}
              >
                See the full project
              </Link>
            )}
          </div>
        </div>
      </article>
    );
  }
}

export default NewPost;



/** WEBPACK FOOTER **
 ** ./src/components/NewPost.js
 **/